import { useSegmentCode } from '@rewardops/auth'
import { useLocale } from '@rewardops/ui'
import { ResponseOption } from '@rewardops/utils'

import { SEARCH_QUERY_MIN_LENGTH } from '~/utils/sort-utils'
import { useApi } from '../use-api'

type FilterParams = {
  isAffiliate?: boolean
  isPromotion?: boolean
  promotionLabel?: string
  categoryCode?: string
  subCategoryCode?: string
}

type ParametersFilterProps = {
  searchQuery?: string
  filter?: FilterParams
  earnRate?: string
  enabled?: boolean
}

type BrandResponseOption = {
  filter_definition: string
  id: number
  image: string
  key: string
  name: string
}

export const useParametersFilter = ({
  searchQuery = '',
  filter = {},
  earnRate = '',
  enabled = true,
}: ParametersFilterProps) => {
  const { api } = useApi()
  const segmentCode = useSegmentCode()
  const { locale } = useLocale()

  const { data: filtersData, isLoading } =
    api.items.getQueryParameters.useQuery(
      {
        segment_code: segmentCode,
        accept_language: locale,
        filter: filter,
        labels: ['brands'],
        custom_category: 'offer_contract_segment',
        ...(earnRate ? { earn_rate: earnRate } : {}),
        ...(searchQuery && searchQuery?.length >= SEARCH_QUERY_MIN_LENGTH
          ? { q: searchQuery }
          : {}),
      },
      {
        enabled: enabled,
        staleTime: 0,
        cacheTime: 0,
      },
    )

  const loading = enabled && isLoading

  const subCategories =
    filtersData?.result?.find(
      (option: ResponseOption) => option.type === 'CustomLabel::Category',
    )?.options || []

  const brands =
    filtersData?.result?.find(
      (option: ResponseOption) => option?.type === 'Label::Brand',
    )?.options || []

  const sortedBrands = brands?.sort(
    (a: BrandResponseOption, b: BrandResponseOption) =>
      a?.name?.localeCompare(b?.name),
  )

  const earnRates =
    filtersData?.result?.find(
      (option: ResponseOption) => option?.type === 'Earn Rate',
    )?.options || []

  const subCategoriesCodes = subCategories?.map(
    (subCategory: any) => subCategory?.code,
  )

  return {
    subCategories,
    subCategoriesCodes,
    brands: sortedBrands,
    earnRates,
    loading,
  }
}
